import connection from "../connection";
import {serialize} from "object-to-formdata";

export const getMatches = async (leagueEditionId, leagueId, leagueCategoryId, leagueDivisionId) =>
   connection.get("v1/current_user/matches", {
      league_edition_id: leagueEditionId,
      league_id: leagueId,
      league_category_id: leagueCategoryId,
      league_division_id: leagueDivisionId
   });

export const getRecentMatches = async (leagueEditionId, leagueId, leagueCategoryId, leagueDivisionId) =>
   connection.get("v1/current_user/matches/recent_matches", {
      league_edition_id: leagueEditionId,
      league_id: leagueId,
      league_category_id: leagueCategoryId,
      league_division_id: leagueDivisionId
   });

export const getMatchList = async (enrollmentId, leagueEditionId, leagueId, leagueCategoryId, leagueDivisionId) =>
   connection.get("v1/current_user/matches/list", {
      enrollment_id: enrollmentId,
      league_edition_id: leagueEditionId,
      league_id: leagueId,
      league_category_id: leagueCategoryId,
      league_division_id: leagueDivisionId
   });

export const getMatchesCompetition = async (leagueEditionId, leagueId, leagueCategoryId, leagueDivisionId) =>
   connection.get("v1/current_user/matches/matches_for_competition", {
      league_edition_id: leagueEditionId,
      league_id: leagueId,
      league_category_id: leagueCategoryId,
      league_division_id: leagueDivisionId
   });

export const getMatchDetails = async matchId =>
   connection.get(`v1/current_user/matches/${matchId}/details`);

export const scheduleMatch = async (matchId, clubId, date) =>
   connection.post(`v1/current_user/matches/${matchId}/schedule`, {
      club_id: clubId,
      date
   });

export const sendMatchResults = async (matchId, teamAScore, teamBScore, photo, noAttendance, noAttendanceReason, noAttendanceDescription) => {
   let formData = serialize({
      team_a: {first_set: parseInt(teamAScore.firstSet), second_set: parseInt(teamAScore.secondSet), third_set: teamAScore.thirdSet !== '' ? parseInt(teamAScore.thirdSet) : ''},
      team_b: {first_set: parseInt(teamBScore.firstSet), second_set: parseInt(teamBScore.secondSet), third_set: teamBScore.thirdSet !== '' ? parseInt(teamBScore.thirdSet) : ''},
      file: photo,
      no_attendance: noAttendance,
      reason: noAttendanceReason,
      description: noAttendanceDescription
   });

   await connection.post(`v1/current_user/matches/${matchId}/score`, formData);
}

export const uploadMatchPhoto = async (matchId, photo) => {
  try {
    const formData = serialize({ file: photo });
    const response = await connection.put(`v1/current_user/matches/${matchId}/upload_photo`, formData);

    return {
      success: true,
      photo: response?.data?.photo_url || null
    };
  } catch (err) {
    console.error("Upload match photo failed:", err);
    return { success: false };
  }
};

export const cancelMatchSchedule = async (matchId, reason, didMyTeamCancel) =>
   connection.post(`v1/current_user/matches/${matchId}/cancel_scheduled_date`, {
      notes: reason,
      did_my_team_cancel: didMyTeamCancel
   });

export const contactPlayers = async (matchId, message) =>
   connection.post(`v1/current_user/matches/${matchId}/temptive_schedule.json`, {
      msg: message
   });

export const contactPlayersAnswer = async (matchId, users, message) =>
   connection.post(`v1/current_user/matches/${matchId}/temptive_schedule_answer`, {
      users,
      message
   });

export const suspendMatch = async (matchId, matchScore, lastDoubleServe, reason) =>
   connection.post(`v1/current_user/matches/${matchId}/suspend_match`, {
      match_score: matchScore,
      last_double_serve: lastDoubleServe,
      reason
   });

export const sendSchedulingComplaints = async (matchId, reason, description) =>
   connection.post(`v1/current_user/matches/${matchId}/send_scheduling_complaints`, {
      reason,
      description
   });
